import moment from "moment";
import trim from "lodash/trim";
import { extractRangeFromString } from "components/common/EntityFilters/helpers/timeRange";
import { adjustFormat } from "util/DateTime";
const isNullOrBlank = (s) => {
  if (!s) {
    return true;
  }
  return trim(s) === "";
};
const parseTimerangeFilter = (timestamp, defaultTimerange) => {
  if (!timestamp) {
    return defaultTimerange;
  }
  const [from, to] = extractRangeFromString(timestamp);
  if (!from && !to) {
    return defaultTimerange;
  }
  return {
    type: "absolute",
    from: isNullOrBlank(from) ? adjustFormat(moment(0).utc(), "internal") : from,
    to: isNullOrBlank(to) ? adjustFormat(moment().utc(), "internal") : to
  };
};
export default parseTimerangeFilter;
